/**
 * leadership-card
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_leadership-card.scss';

// Module template
import './_leadership-card.twig';

export const name = 'leadership-card';

export const defaults = {
  dummyClass: 'js-leadership-card-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { leadershipCard = {} }) {
  // Find our component within the DOM
  const $leadershipCard = $('.leadership-card', $context);
  // Bail if component does not exist
  if (!$leadershipCard.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...leadershipCard,
  };
  // An example of what could be done with this component
  $leadershipCard.addClass(settings.dummyClass);
}

$(document).ready(() => {
  $('.leadership-card .cover-link').click((e) => {
    const $this = $(e.target).closest('.leadership-card');
    const $cardClone = $this.clone().addClass('leadership-card-clone');
    console.log($cardClone);

    $('body').append(
      '<div class="leadership-card-modal"><div class="leadership-card-overlay"><span class="modaal-close"></span></div></div>'
    );

    $('.leadership-card-modal').append($cardClone);
  });

  $(document).on('click', '.leadership-card-overlay', () => {
    $('.leadership-card-modal').remove();
  });
});

export default enable;
